import GerepAPI from './GerepAPI'

export default class ContactService {

    static getNavMenu(token, values) {
        return GerepAPI.get('/navMenu', values, token)
    }
}
